import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDateUtils, validateCurrency, validateRuppes } from "../../../utils/formatTime";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";
import "./style.css";
export default function MoreCardDetails({
  selectedFilter,
   SelectedCardData,
  selectedCardName,
  selectedCountFilter,
  fromDate,
  toDate,
  selectedYear,
  monthName,
  countryId
}) {
  const { currentMonthName, lastMonthName, weekRange, currentYear } =
    useDateUtils();
console.log("selectedFilter" ,selectedFilter ,fromDate)

  let currentDate = new Date().toISOString().split("T")[0];


  const [processedRows, setProcessedRows] = useState([]);

  useEffect(() => {
    if (!SelectedCardData || SelectedCardData.length === 0) {
      setProcessedRows([]);
      return;
    }

    // Clone the array to avoid mutating props
    const tempData = [...SelectedCardData];

    // Extract total row (last one)
    const totalRow = tempData.pop();

    // Separate rows
    const misRows = tempData.filter(
      (row) => row.is_miscellaneous_revenue === 1
    );
    const normalRows = tempData.filter(
      (row) => row.is_miscellaneous_revenue !== 1
    );

    // Create a header row for miscellaneous
    const headerRow = {
      id: "header-misc",
      isHeader: true,
      name: "Miscellaneous Payments",
    };

    let finalRows = [];

    if (misRows.length === 0) {
      finalRows = [...normalRows, totalRow];
    } else {
      finalRows = [...normalRows, headerRow, ...misRows, totalRow];
    }

    

    setProcessedRows(finalRows);
  }, [SelectedCardData]);



  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.enquiry_id?.first_name || ""} ${
          params?.row?.enquiry_id?.last_name || ""
        }`,
      renderCell: (params) => {
        if (params.row.isHeader) {
          return (
            <div
              style={{
                fontWeight: "bold",
                textAlign: "center",
                width: "100%",
                fontSize: "1rem",
              }}
            >
              {params.row.name}
            </div>
          );
        }

        else{ 
        // Get all row IDs in sorted order
        const allRowIds = params.api.getSortedRowIds?.() || [];

        // Get the last row ID
        const lastRowId = allRowIds[allRowIds.length - 1];

        // Check if the current row is the last row
        const isLastRow = params.id === lastRowId;

        return (
          <div
            style={{
              color: isLastRow ? "black" : "#0096FF",
              fontWeight: isLastRow ? "bold" : "normal",
              cursor: "pointer",
            }}
            onClick={() =>
              window.open(
                `/enquirydetails/${params?.row.enquiry_id?.id}`,
                "_blank"
              )
            }
          >
            {params?.row?.enquiry_id?.first_name || ""}{" "}
            {params?.row?.enquiry_id?.last_name || ""}
          </div>
        );
    }
  
      },
         colSpan: (params) => (params.row.isHeader ? 8 : undefined),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.enquiry_id?.mobile || "",
      renderCell: (params) => {
     
        return <div>{params?.row.enquiry_id?.mobile}</div>;
      },

    },
    {
      field: "branch",
      headerName: "Enrolled Branch",
      flex: 1,
      minWidth: 200,
      headerClassName: "header-cell",
      renderCell: (params) => {
    
        return <div>{params?.row?.branch_id?.branch_name }</div>;
      },

    //   cellClassName: (params) => (params.row.isHeader ? "hide-cell" : ""),
    },

      {
      field: "branch_collected",
      headerName: "Collected By Branch",
      flex: 1,
      minWidth: 200,
      headerClassName: "header-cell",
      renderCell: (params) => {
    
        return <div>{params?.row?.branch_collected_by?.branch_name }</div>;
      },

    //   cellClassName: (params) => (params.row.isHeader ? "hide-cell" : ""),
    },
    {
      field: "test_type",
      headerName: "Test Type",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      renderCell: (params) => {
    
        return <div>{params?.row?.test_type_id?.name }</div>;
      },
    //   cellClassName: (params) => (params.row.isHeader ? "hide-cell" : ""),
    },
    {
      field: "class",
      headerName: "Class/Program",
      flex: 1,
      minWidth: 200,
      headerClassName: "header-cell",
      renderCell: (params) => {
    
        return <div>{params?.row?.class_id?.name || params?.row?.scholars_program_id?.name }</div>;
      },
    //   cellClassName: (params) => (params.row.isHeader ? "hide-cell" : ""),
    },

    
    {
      field: "package",
      headerName: "Package",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => {
     
        return <div>{params?.row?.package_id?.package_name}</div>;
      },
 
    },
    {
      field: "collect_date",
      headerName: "Collected Date",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      renderCell: (params) => {
     
        return <div>{params?.row?.collect_date}</div>;
      },
    
    },
    {
      field: "collected_by",
      headerName: "Collected By",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => {
      
        return (
          <div>
            {params?.row?.collected_by?.first_name}{" "}
            {params?.row?.collected_by?.last_name}
          </div>
        );
      },
    //   cellClassName: (params) => (params.row.isHeader ? "hide-cell" : ""),
    },
    {
      field: "amount",
headerName: `Amount ${countryId ? `(${validateRuppes(countryId)})` : ""}`,

      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      renderCell: (params) => {
    
        return <div>{params?.row?.amount}</div>;
      },
    //   cellClassName: (params) => (params.row.isHeader ? "hide-cell" : ""),
    },
  ];

  const filteredColumns =
    // selectedCountFilter === "total_revenue" ||
    selectedCountFilter === "pending_revenue"
      ? columns.filter((col) => col.field !== "collect_date")
      : columns;

  const [paginationModel, setPaginationModel] = useState({
    page: 0, // Initial page
    pageSize: 25, // Initial page size
  });

  const isLastRowOnCurrentPage = () => {
    const totalRows = SelectedCardData.length;
    const { page, pageSize } = paginationModel;

    // Calculate the range of indexes for the current page
    const startIndex = page * pageSize;
    const endIndex = startIndex + pageSize - 1;

    return totalRows - 1 >= startIndex && totalRows - 1 <= endIndex;
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {selectedFilter === "today" && (
          <Typography variant="h4" textAlign="center">
            Today ({currentDate})
          </Typography>
        )}
        {selectedFilter === "currentweek" && (
          <Typography variant="h4" textAlign="center">
            This Week ({weekRange})
          </Typography>
        )}

        {selectedFilter === "currentmonth" && (
          <Typography variant="h4" textAlign="center">
            {currentMonthName} {currentYear}
          </Typography>
        )}

        {selectedFilter === "custom" && (
          <Typography variant="h4" textAlign="center">
            {fromDate} - {toDate}
          </Typography>
        )}

        {selectedFilter === "default" && (
          <Typography variant="h4" textAlign="center">
            {monthName} {selectedYear}
          </Typography>
        )}
      </Grid>

      <Grid item xs={12}>
        <DataGrid
          rows={processedRows}
          columns={filteredColumns}
          autoHeight
          pageSizeOptions={[25, 50, 100]}
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
          }}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          getRowClassName={(params) =>
            isLastRowOnCurrentPage() &&
            params.id === SelectedCardData[SelectedCardData.length - 1].id
              ? "last-row"
              : ""
          }
          getRowHeight={(params) => (params.model.isHeader ? 50 : null)}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
        />
      </Grid>
    </Grid>
  );
}
